import {defineStore} from 'pinia';
import {ref, type Ref} from 'vue';

export const useAppStore = defineStore('appStore', () => {
	const isLoggedIn: Ref<boolean> = ref(window.loggedIn);
	const filterExpanded: Ref<boolean> = ref(false);
	const filterBlockActive: Ref<boolean> = ref(true);
	const substituteModalActive: Ref<boolean> = ref(false);
	const exportModalActive: Ref<boolean> = ref(false);
	const confirmClearFavoritesModalActive: Ref<boolean> = ref(false);

	const activeUserCountries: Ref<Array<string>> = ref(window.activeWebShopCountries);

	const setFilterExpanded = (newValue: boolean) => filterExpanded.value = newValue;

	const setFilterBlockActive = (newValue: boolean) => filterBlockActive.value = newValue;

	const toggleFilterBlock = () => setFilterBlockActive(!filterBlockActive.value);

	const getPrimaryUserRegion = (): string | null => {
		return activeUserCountries.value?.length > 0 ? activeUserCountries.value[0]?.toLowerCase() : null;
	};

	const isAllowedToOrder = (region: string): boolean => {
		if (!region) {
			return false;
		}

		return activeUserCountries.value?.some(userCountry => userCountry?.toLowerCase() === region.toLowerCase());
	}

	return {
		isLoggedIn,
		filterExpanded,
		filterBlockActive,
		substituteModalActive,
		exportModalActive,
		confirmClearFavoritesModalActive,
		isAllowedToOrder,
		getPrimaryUserRegion,
		setFilterExpanded,
		setFilterBlockActive,
		toggleFilterBlock
	};
});
